import { stateKey } from './actions'

export const selectModalType = (state) => state[stateKey].modalStack.at(-1) || null
export const selectModalProps = (state) => state[stateKey].modalProps
export const selectModalIsOpen = (state) => state[stateKey].isOpen
export const selectModalStack = (state) => state[stateKey].modalStack

